import { render, staticRenderFns } from "./FormDialog.vue?vue&type=template&id=1518f75c&scoped=true&"
import script from "./FormDialog.vue?vue&type=script&lang=js&"
export * from "./FormDialog.vue?vue&type=script&lang=js&"
import style0 from "./FormDialog.vue?vue&type=style&index=0&id=1518f75c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1518f75c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1518f75c')) {
      api.createRecord('1518f75c', component.options)
    } else {
      api.reload('1518f75c', component.options)
    }
    module.hot.accept("./FormDialog.vue?vue&type=template&id=1518f75c&scoped=true&", function () {
      api.rerender('1518f75c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormDialog.vue"
export default component.exports